import "../src/assets/css/style.css";

import Routes from "./Pages/Routes";
import { NavProvider } from "./state/NavContext";
import { SideProvider } from "./state/SideContext";
import { UserProvider } from "./state/UserContext";

function App() {
  return (
    <>
      <UserProvider>
        <NavProvider>
          <SideProvider>
            <Routes />
          </SideProvider>
        </NavProvider>
      </UserProvider>
    </>
  );
}

export default App;
